import { UserDataStore } from '@/store/user-store/user-data.store';
import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, take, map, firstValueFrom } from 'rxjs';
import { GlobalOrderHelpersService } from '../services/global-order-helpers.service';
import { RoleAccessService } from '@/core/service/role-access/role-access.service';
import { SeccionesRolesEnum } from '@/core/enum/RolSeccions.enum';

export const marineOrderGuard: CanActivateFn = async () => {
  const userStore = inject(UserDataStore);
  const router = inject(Router);
  const globalOrderHelper = inject(GlobalOrderHelpersService);
  const rolesService = inject(RoleAccessService);

  return await firstValueFrom(
    toObservable(userStore.isLoaded).pipe(
      filter(loaded => loaded),
      take(1),
      map(() => {
        const canPass =
          globalOrderHelper.isMarineInternacional() &&
          rolesService.isVisibleForRol(SeccionesRolesEnum.PEDIDOS_NUEVO_PEDIDO_MARINE) &&
          rolesService.isVisibleForRol(SeccionesRolesEnum.PEDIDOS_NOMINACIONES);

        return canPass ? true : router.createUrlTree(['/portal/home']);
      }),
    ),
  );
};
